import angular from 'angular';
import loansMandatoryInsuranceModalComponent from './loansMandatoryInsuranceModal.component';

let loansMandatoryInsuranceModalModule = angular.module('loansMandatoryInsuranceModal', [
])

.component('loansMandatoryInsuranceModal', loansMandatoryInsuranceModalComponent)

.name;

export default loansMandatoryInsuranceModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansMandatoryInsuranceModal/loansMandatoryInsuranceModal.js